import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {ContentHomeNoticeVo} from '../../common/shared/api/nicolas/vo/ContentHomeNoticeVo.interface';

/**
 * 콘텐츠 홈 공지사항 조회
 *
 * Origin: pageNicolasApi.getContentHomeNotice
 * API: GET /api/v1/content/notice
 */
export async function getContentNotice(
  {
    seriesId,
    page = 0,
  }: {
    seriesId: number;
    page?: number;
  },
  options?: FetcherOptions
): Promise<ApiResultVo & {result: ContentHomeNoticeVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/content/notice',
    {
      method: 'GET',
      params: {
        series_id: seriesId,
        page,
      },
    },
    options
  );
  return response.data;
}
